module.exports = __webpack_public_path__ + "img/tripdaze-2.5584b697.jpg";